<template>
    <div class="container-fluid">
        <admin-header :name="$t('Users')"/>
        <app-card>
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <router-link to="/auth/users" class="nav-link" exact>
                        {{ $t('Users') }}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/auth/users/roles" class="nav-link" exact>
                        {{ $t('Roles') }}
                    </router-link>
                </li>
            </ul>
            <div class="tab-content">
                <router-view name="users"/>
            </div>
        </app-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    computed: {},
    methods: {
    },
    components: {
    },
    created() {
    }
};
</script>
